baseApp.service('ChartsService', ['$filter', function($filter) {
	var commonLineGraph = {
		lineThickness: 1,
		dateFormat: 'JJ:NN:SS DD, YYYY',
		fontSize: 3,
		fillAlphas: 0.1,
		valueAxis: 'ValueAxis-1',
		balloonFunction: function(graphDataItem) {
			return $filter('bits')(Math.abs(graphDataItem.values.value), 1) + 'ps';
		},
	};
	var commonColumnGraph = {
		lineThickness: 1,
		dateFormat: 'JJ:NN:SS DD, YYYY',
		fillAlphas: 0.33,
		fontSize: 4,
		"type": "column",
		valueAxis: 'ValueAxis-2',
		"clustered": false,
		useLineColorForBulletBorder: true,
		balloonFunction: function(graphDataItem) {
			return $filter('bits')(Math.abs(graphDataItem.values.value), 1) + 'ps';
		},
	};
	var percentColumnGraph = {
		lineThickness: 2,
		dateFormat: 'JJ:NN:SS DD, YYYY',
		fillAlphas: 0.33,
		fontSize: 4,
		"type": "column",
		valueAxis: 'ValueAxis-3',
		"clustered": false,
		useLineColorForBulletBorder: true,
		balloonFunction: function(graphDataItem) {
			return Math.abs(graphDataItem.values.value) + '%';
		},
	};
	var commonPieChartSettings = {
		type: 'pie',
		theme: 'new',
		dataProvider: [],
		valueField: 'throughput',
		titleField: 'name',
		"labelField": "name",
		fontSize: 8,
		labelRadius: 2,
		labelsEnabled: false,
		pullOutRadius: 0,
		"radius": 9,
		"outlineThickness": 1,
		"balloonText": "",
	};
	var commonSerialChartSettings = {
		type: 'serial',
		fontFamily: 'Roboto',
		addClassNames: true,
		path: '/public/javascripts/external/amcharts/',
		pathToImages: '/public/javascripts/external/amcharts/images/',
		categoryField: 'timestamp',
		theme: 'new',
		autoMargins: false,
		marginTop: 5,
		marginBottom: 25,
		marginLeft: 90,
		marginRight: 30,
		categoryAxis: {
			gridAlpha: 0.15,
			minPeriod: '1000fff',
			markPeriodChange: true,
			parseDates: true,
			dashLength: 1,
			offset: 0,
			dateFormats: [{ period: 'fff', format: 'JJ:NN:SS' }, { period: 'ss', format: 'JJ:NN:SS' },
				{ period: 'mm', format: 'JJ:NN' }, { period: 'hh', format: 'JJ:NN' },
				{ period: 'DD', format: 'MMM DD' }, { period: 'WW', format: 'MMM DD' },
				{ period: 'MM', format: 'MMM' }, { period: 'YYYY', format: 'YYYY' }
			],
			centerLabelOnFullPeriod: true,
			centerLabels: false,
			ignoreAxisWidth: true,
		},
		chartCursor: {
			cursorPosition: 'mouse',
			categoryBalloonDateFormat: 'JJ:NN:SS',
			zoomable: false,
		},
		trendLines: [],
		legend: false,
		guides: [],
		allLabels: [],
		graphs: [],
	};
	var commonValueAxis = {
		labelsEnabled: true,
		titleFontSize: 10,
		gridAlpha: 0.02,
		axisAlpha: 1,
		zeroGridAlpha: 2,
		includeHidden: true,
		includeAllValues: true,
		axisThickness: 1,
	};
	function getMaxValueInChart(chart) {
		var min = 0,
			max = 0,
			x;
		var valueFields = chart.graphs.map(function(graph) { return graph.valueField});
		chart.dataProvider.forEach(function(dataItem) {
			valueFields.forEach(function(valueField) {
				min = Math.min(min, dataItem[valueField] || 0);
				max = Math.max(max, dataItem[valueField] || 0);
			});
		});
		return Math.max(max, Math.abs(min));
	}

	function getMaxValueInChartByAxis(chart) {
		var min = 0,
			max = 0,
			x = 0;
		for (x = 0; x < chart.valueAxes.length; x++) {
			var axis = chart.valueAxes[x];
			var minValue = axis.minRR;
			var maxValue = axis.maxRR;
			maxValue = Math.max(Math.abs(axis.minRR), axis.maxRR);
			minValue = -1 * maxValue;
			if (minValue !== -Infinity && minValue < min) {
				min = minValue;
			}
			if (maxValue !== Infinity && maxValue > max) {
				max = maxValue;
			}
		}

		return Math.max(max, Math.abs(min));
	}

	return {
		getCommonValueAxis: function(newConf) { return newConf? _.merge(angular.copy(commonValueAxis), newConf) : angular.copy(commonValueAxis)},
		getCommonPieChartSettings: function(newConf) { return newConf? _.merge(angular.copy(commonPieChartSettings), newConf) : angular.copy(commonPieChartSettings)},
		getCommonSerialChartSettings: function(newConf) { return newConf? _.merge(angular.copy(commonSerialChartSettings), newConf) : angular.copy(commonSerialChartSettings)},
		getPercentColumnGraph: function(newConf) { return newConf? _.merge(angular.copy(percentColumnGraph), newConf) : angular.copy(percentColumnGraph)},
		getCommonColumnGraph: function(newConf) { return newConf? _.merge(angular.copy(commonColumnGraph), newConf) : angular.copy(commonColumnGraph) },
		getCommonLineGraph: function(newConf) { return newConf? _.merge(angular.copy(commonLineGraph), newConf) : angular.copy(commonLineGraph)},
		setAxiScale: function(chart, stack) {
			var maxValue = 0;
			if (stack) {
				maxValue = getMaxValueInChartByAxis(chart);
			} else {
				maxValue = getMaxValueInChart(chart);
			}

			for (var x = 0; x < chart.valueAxes.length; x++) {
				chart.valueAxes[x].minimum = (maxValue*-1) - 1;
				chart.valueAxes[x].maximum = maxValue + 1;
			}
		},
		updateChart: function(chart, newChartData, options) {
			options = options || {};
			chart.dataProvider = newChartData;
			//chart.validateData();
			if (options.setAxiScale) {
				this.setAxiScale(chart, options.stack);
			}
			chart.validateData();
		},
		packetLossLabelFunction: function() {

		},
		mossLabelFunction: function(value) {
			return Math.abs(value);
		},
		newGraph: function(chart, options) {
			options = options || {};
			var newGraph = new AmCharts.AmGraph();

			var graphConfig = {
				id: options.id,
				title: options.title,
				valueField: options.valueField,
				stackable: options.stackable || false,
				fillAlphas: options.stackable ? 1 : 0.1,
				lineColor: options.lineColor,
				valueAxis: options.valueAxis,
			};

			graphConfig = options.type === 'line' ? this.getCommonLineGraph(graphConfig) : this.getCommonColumnGraph(graphConfig);

			if (options.balloonType) {
				if (options.balloonType === 'time') {
					graphConfig.balloonFunction = function(graphDataItem) {
						return Math.abs(graphDataItem.values.value) + 'ms';
					};
				} else if (options.balloonType === 'percent') {
					graphConfig.balloonFunction = function(graphDataItem) {
						return Math.abs(graphDataItem.values.value) + '%';
					};
				} else if (options.balloonType === 'abs') {
					graphConfig.balloonFunction = function(graphDataItem) {
						return Math.abs(graphDataItem.values.value) + '';
					};
				}
			}

			for (var optionsKey in graphConfig) {
				newGraph[optionsKey] = graphConfig[optionsKey];
			}

			chart.addGraph(newGraph);

			return newGraph;
		},
		graphColors: ["#9c27b0", "#009688", "#158864", "#607d8b", "#a61df9"],
	}
}]);